import { SharedModule } from '$shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { HeaderPanelComponent } from './header-panel/header-panel.component';
import { HeaderUserComponent } from './header-user/header-user.component';
import { HeaderComponent } from './header.component';
import { LangSelectorComponent } from './lang-selector/lang-selector.component';
import { LoaderComponent } from './loader/loader.component';
import { NotificationsModule } from '$modules/personal/notifications/notifications.module';
import { BrowserDeprecationWarningComponent } from './browser-deprecation-warning/browser-deprecation-warning.component';

@NgModule({
  declarations: [
    HeaderComponent,
    HeaderMenuComponent,
    HeaderUserComponent,
    HeaderPanelComponent,
    LoaderComponent,
    LangSelectorComponent,
    BrowserDeprecationWarningComponent,
  ],
  imports: [CommonModule, SharedModule, NotificationsModule],
  exports: [HeaderComponent, LoaderComponent],
})
export class HeaderModule {}
